const addCustomFormatters = () => {
    
    rivets.binders.min_maxclass = function(el, item) {
        $(el).parents('.qtyField').find('.qty-trigger').attr('data-item',item.id);
        if(item.minimum_cart && item.minimum_cart != ""){
            $(el).parents('.qtyField').find('.qty-trigger').attr('data-min',item.minimum_cart);
        }else{
            $(el).parents('.qtyField').find('.qty-trigger').removeAttr('data-min');
        }
        if(item.maximum_cart && item.maximum_cart != ""){
            $(el).parents('.qtyField').find('.qty-trigger').attr('data-max',item.maximum_cart);
        }else{
            $(el).parents('.qtyField').find('.qty-trigger').removeAttr('data-max');
        }
        let dynamic_variable = "flyout_quantity_validation_timer_item_"+item.id;
        let warning_msg = "";
        if(item.maximum_cart && item.maximum_cart != "" ){
            warning_msg = window.max_msg_on_cart_flyout.replaceAll('XXX',item.maximum_cart);
        }
        if(item.minimum_cart && item.minimum_cart != "" ){
            warning_msg = window.min_msg_on_cart_flyout.replaceAll('XXX',item.minimum_cart);
        }
        if(warning_msg != ""){
            $(el).parents('.cart-item').find('.flayout-quantity-validation-show-message').text(warning_msg).removeClass('tw-hidden');
        }else{
            $(el).parents('.cart-item').find('.flayout-quantity-validation-show-message').addClass('tw-hidden');
        }
        if(item.minimum_cart && item.minimum_cart != "" && item.quantity <= item.minimum_cart){
            let error_msg = window.min_msg_on_cart_flyout.replaceAll('XXX',item.minimum_cart);
            $(el).parents('.qtyField').find('.qty-minusdrawer').addClass('disabled');
            if(typeof window[dynamic_variable] !== 'undefined'){
                $(el).parents('.qtyField').find('.flayout-min-max-quantity-error').removeClass('tw-hidden').find('.error-msg').text(error_msg);
                setTimeout(function() {
                    $(el).parents('.qtyField').find('.flayout-min-max-quantity-error').addClass('tw-hidden')
                },window.min_max_time_to_show);
                delete window[dynamic_variable];
            }
        }else{
            $(el).parents('.qtyField').find('.qty-minusdrawer').removeClass('disabled');
        }
        if(item.maximum_cart && item.maximum_cart != "" && item.quantity >= item.maximum_cart){
            let error_msg = window.max_msg_on_cart_flyout.replaceAll('XXX',item.maximum_cart);
            $(el).parents('.qtyField').find('.qty-plusdrawer').addClass('disabled');
            if(typeof window[dynamic_variable] !== 'undefined'){
                $(el).parents('.qtyField').find('.flayout-min-max-quantity-error').removeClass('tw-hidden').find('.error-msg').text(error_msg);
                setTimeout(function() {
                    $(el).parents('.qtyField').find('.flayout-min-max-quantity-error').addClass('tw-hidden')
                },window.min_max_time_to_show);
                delete window[dynamic_variable];
            }
        }else{
            $(el).parents('.qtyField').find('.qty-plusdrawer').removeClass('disabled');
        }
    }

    const hasCooledge = items =>  {
        return items.some(item => item.vendor.toLowerCase() === 'cooledge')
    }

    rivets.formatters.isImageWithBorder = function(item, args) {
        let productsWithBorders = ['Accessories']
        let hasBorder = false;
        if (productsWithBorders.includes(item.product_type)){
            hasBorder = true;
        }
        return hasBorder;
    }

    rivets.formatters.isDefaultTile = function(item, args) {
        return !item?.product_has_only_default_variant;
    }
    
    const getTotalItems = items => {
        const totalItems = items.reduce((total_items, item) => {
            if(typeof surchargeVariantId !== 'undefined' && item.id == surchargeVariantId) return total_items;
            return total_items + item.quantity;
        },0);
        return totalItems;
    }

    //Cart Flyout custom Formatters
    rivets.formatters.compare = function(value,args){
        return value != args;
    }
    //Review if final price has discount and isn't a surcharge discount
    rivets.formatters.compareRPA = function(item, args) {
        
        const hasVolDiscount = item.properties.hasOwnProperty('_volumeDiscountApplied') && (item.properties._volumeDiscountApplied === 'true' || item.properties._volumeDiscountApplied === true) ? true : false;
        const applyVolDiscountAmount = item.properties.hasOwnProperty('_applyVolumeDiscountAmount') && (item.properties._applyVolumeDiscountAmount === 'true' || item.properties._applyVolumeDiscountAmount === true) ? true : false;
        const hasDiscount = item.properties.hasOwnProperty('_discount') ? true : false;
        const hasRPADiscount = item.properties.hasOwnProperty('__rpaPercentage') && item.properties.__rpaPercentage.includes('-') && (hasVolDiscount === false && hasDiscount == false) ? true : false;
        if (applyVolDiscountAmount === true) {
            return false;
        }
        return item.final_price != item.original_price && hasRPADiscount == args;
    }
    
    //Evaluate if the item apply VolumeAmount
    rivets.formatters.applyVolumeAmount = function(item) {
        const applyVolDiscountAmount = item.properties.hasOwnProperty('_applyVolumeDiscountAmount') && (item.properties._applyVolumeDiscountAmount === 'true' || item.properties._applyVolumeDiscountAmount === true) ? true : false;
        
        return applyVolDiscountAmount;
    }
    rivets.formatters.isEnableVolComponent = function(items , minimumQty) {
        var showVolComponent = false;
        var itemsQty = 0;
        var hasPercentDiscount = false;
        var hasAmountDiscount = false;
    
        items.forEach(function(item) {
            if (item.properties.hasOwnProperty('_volumeQuantity') && item.properties._volumeQuantity !== '0') {
                var applyVolDiscountAmount = item.properties.hasOwnProperty('_applyVolumeDiscountAmount') && (item.properties._applyVolumeDiscountAmount === 'true' || item.properties._applyVolumeDiscountAmount === true);
                
                if (applyVolDiscountAmount) {
                    hasAmountDiscount = true;
                } else {
                    hasPercentDiscount = true;
                }
    
                itemsQty += parseInt(item.quantity) || 0;
            }
        });
    
        if (hasPercentDiscount && !hasAmountDiscount && itemsQty >= minimumQty) {
            showVolComponent = true;
        } else if (!hasPercentDiscount && hasAmountDiscount && itemsQty >= minimumQty) {
            showVolComponent = true;
        }
    
        return showVolComponent;
    }
    rivets.formatters.setVolComponent = function(items) {
        const {showComponent} = volMiniCartComponentSelected(items);
        return showComponent;
      };
    rivets.formatters.isTemplok = function(item) {
        return item.properties.hasOwnProperty('_templokRegularVariantId') && item.properties._templokRegularVariantId ?  item.properties._templokRegularVariantId : '';
    }
    // Free shipping upsell
    rivets.formatters.getTotalPrice = function(items, free_shipping_value, remainingPriceForFreeShipping ) {

        var hasItemsWithVolume = items.some(function(item) {
            return item.properties.hasOwnProperty('_volumeQuantity') && item.properties._volumeQuantity !== '0';
        });
        if (!hasItemsWithVolume){
            validateFreeShipping(items,free_shipping_value,remainingPriceForFreeShipping );
            return true;
        }
        else {
            $('.FreeShippingUpsell').addClass('tw-hidden')
            return false; 
        }
        
    }
    //Format the given value to money
    rivets.formatters.custom_money_format = function(value) {
        return theme.Currency.formatMoneyNoRound(value * 100);
    }
    // Return the amount of items in the cart
    rivets.formatters.total_items_custom = function(items) {
        const totalItems = getTotalItems(items);
        return `(${totalItems})`;
    }
    // Return the total amount of the cart based on sum of lines
    rivets.formatters.total_custom = function(items, cart) {
        let total = cart.total_price;
        return total;
    }
       // Return the total amount of the cart based on sum of lines including the RPA cost
       rivets.formatters.total_custom_rpa = function(items, cart) {
        const total = items.reduce((subtotal, item) => {
            if(typeof surchargeVariantId !== 'undefined' && item.id == surchargeVariantId) return subtotal;
            const productSurcharge = item.properties.hasOwnProperty('__rpaPercentage') && !item.properties.__rpaPercentage.includes('-') ? parseInt(item.properties.__rpaPercentage) : 0;
            let lineTotal = item.final_line_price;
            if(productSurcharge !== 0) {
                const rpa = Math.round((item.original_line_price * (productSurcharge / 100)), 0);
                lineTotal = item.final_line_price ;
            }
            return subtotal + lineTotal;
        },0);
        return theme.Currency.formatMoney(total, theme.moneyFormat);
    }

    //Get total price of single item
    rivets.formatters.total_item_price = function(item,type) {
        let price = item[type];
        let subtotal = item.final_line_price;
        if (item.properties.hasOwnProperty('__rpaPercentage') && !item.properties.__rpaPercentage.includes('-')) {
            const surcharge_price = Math.round(item.original_line_price * (item.properties.__rpaPercentage/100));
            subtotal = item.final_line_price ;
        }
        return theme.Currency.formatMoney(subtotal, theme.moneyFormat);
    }
    //Validate if there is more than one vendor
    rivets.formatters.is_single_vendor = function(items) {
        const vendors = items.map(item => item.vendor);
        const uniqueVendors = new Set(vendors);
        return uniqueVendors.size > 1 ? false : true;
    }

     rivets.formatters.vendor_logo = function(item) {
        if(item?.vendor){
            let vendor = item.vendor;
            vendor = vendor.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            let key = vendor + "_logo";
            return shop_vendors[key];
        }
        return false;
    }
    rivets.formatters.vendor_name = function(item) {
        if(item?.vendor){
            let vendor = item.vendor;
            vendor = vendor.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            let key = vendor + "_text";
            console.log("Vendor Name Key: ", key);
            console.log(shop_vendors[key]);
            return shop_vendors[key];
        }
        return false;
     }

    //Validate if the vendor of the first item matches the provided vendor
    rivets.formatters.is_vendor = function(items, vendor) {
        if(items.length === 0) return false;
        return items[0].vendor === vendor;
    }

    //Get the subtotal text with the number of items in the cart
    rivets.formatters.subtotal_text = function(items) {
        const totalItems = getTotalItems(items);
        const itemsText = totalItems === 1 ? 'item' : 'items';
        return ` (${totalItems} ${itemsText}): `;
    }

    //Validate if there is a cooledge item in the cart
    rivets.formatters.has_cooledge = function(items) {
        return hasCooledge(items);
    }

    /*
    Validate if discounts claimer should be hidden according to the next rules:
        1.- There is a cooledge item in the cart
        2.- Discounts are disabled
        3.- VolUpsell is not visible
    */
    rivets.formatters.discounts_claimer_visibility = function(items) {
        setTimeout(() => {
            if (isElementInViewport('.volumeComponentMiniCart')) {
                $('.tw-promotion-cartflyout-row').addClass('tw-hidden');
                $('.freShippingMsg-js').removeClass('tw-hidden');
            } else {
                $('.tw-promotion-cartflyout-row').removeClass('tw-hidden');
                $('.freShippingMsg-js').addClass('tw-hidden');  
            }
            if ( hasCooledge(items)){
                $('.tw-promotion-cartflyout-row').addClass('tw-hidden');
                $('.freShippingMsg-js').addClass('tw-hidden');  
            }
        }, 500);
        return hasCooledge(items) || (localStorage.getItem('applyDiscount') === 'false' && localStorage.getItem('applyVolDiscount') === 'false') ? true : false;
        
    }

    /*
    Validate if free shipping text should be hidden according to the next rules:
        1.- There is a cooledge item in the cart
        2.- Discounts are active
    */
    rivets.formatters.free_shipping_visibility = function(items) {      
        return hasCooledge(items) || localStorage.getItem('applyDiscount') === 'true' ? true : false;
    }

    /*
    Validate if installation services should be hidden according to the next rules:
        1.- All items are samples
        2.- There is at least one bundle item (Not yet)
    */
    rivets.formatters.installation_services_visibility = function(items) {
        const sampleItems = items.filter(item => item.handle.includes('sample'));
        const allItemsAreSamples = sampleItems.length === items.length ? true : false;
        return allItemsAreSamples;
    }

    //Decrease the item quantity. Setting null instead of 0 prevents the item from being removed from the cart.
    rivets.formatters.reduce_quantity = function(quantity) { 
        const updatedQuantity = quantity - 1;
        return updatedQuantity === 0 ? null : updatedQuantity;
    }
    // Returns the final price of an item with discount and surcharge
    rivets.formatters.getFinalPriceWithRpa = function(item, useOriginalPrice = false) {
        let total = useOriginalPrice ? item.original_line_price : item.final_line_price;
        if(item.properties.hasOwnProperty('__rpaPercentage')) {
            const isLowCharge = item.properties.__rpaPercentage.includes('-');
            if(!isLowCharge || (isLowCharge && useOriginalPrice)) {
                const rpa = 0;
                total = total + rpa;
            }
        }
        return theme.Currency.formatMoney(total, theme.moneyFormat);
    }
    //Get correct url for the item
    rivets.formatters.getLink = function(item) {
        if(window.isLogin == true){
            return item.properties.hasOwnProperty('_sample_url') && item.properties._sample_url ?  item.properties._sample_url : item.url;
        }else{
            if(item.properties.hasOwnProperty('_sample_url') && item.properties._sample_url){
                return item.properties._sample_url
            }else{
                if(item.properties.hasOwnProperty('_allowfornonLogin') && item.properties._allowfornonLogin){
                    return item.url;
                }else{
                    return "javascript:void(0)"
                }   
            }
        }
    }
    //Returns true if the item id matches with the regional pricing adjustement item id 
    rivets.formatters.is_rpa = function(item) {
        if(typeof surchargeVariantId !== 'undefined' && item.id == surchargeVariantId) return true;
        return false;
    }
    //Wraps trademark symbols (® and ™) in sup tags for proper styling
    rivets.formatters.wrapTrademarkSymbols = function(text) {
        if (!text) return text;
        return text
            .replace(/®/g, '<sup class="trademark-symbol">®</sup>')
            .replace(/™/g, '<sup class="trademark-symbol">™</sup>');
    }
}
typeof rivets !== 'undefined' && addCustomFormatters();

